/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayTeamPlayerDtoSchema = z.object({
  userId: z.string().nullish(),
  riotIdGameName: z.string().nullish(),
  riotIdTagLine: z.string().nullish(),
  displayName: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  champion: z.string().nullish(),
  position: z.string().nullish(),
  kills: z.optional(z.int()),
  deaths: z.optional(z.int()),
  assists: z.optional(z.int()),
  cs: z.optional(z.int()),
  gold: z.optional(z.int()),
  damageToChampions: z.optional(z.int()),
  damageTaken: z.optional(z.int()),
  visionScore: z.optional(z.int()),
  wardsPlaced: z.optional(z.int()),
  level: z.optional(z.int()),
});
